export default "__VITE_ASSET__BAngOxXx__"